import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import Apropos from './about.jsx'
import Products from './produits.jsx'
import Service from './services.jsx'
import Temoignages from './testimonial.jsx'
import Partenaires from './partners.jsx'
import Awards from './chiffres.jsx'

import { fadeInDown } from 'react-animations';
import { flipInX } from 'react-animations';
import Radium, {StyleRoot} from 'radium';
import { Bounce, Shake } from 'react-motions'





const styles = {
  fadeInDown: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInDown, 'fadeInDown')
  }
}

const stylesLigh = {
  flipInX: {
    animation: 'x 5s',
    animationName: Radium.keyframes(flipInX, 'flipInX')
  }
}


class Slide extends Component {
  render() {

    return (
    <div>   
 	<section id="intro">
            
            <div className="flexslider fullscreen-carousel hero-slider-1 ">
                <ul className="slides">
                <li data-slide="dark-slide">
                        <div className="slide-bg-image s parallax parallax-section1 amendement_slide">
                            <div className="js-Slide-fullscreen-height container">
                                <div className="intro-content">
                                   
                                     <div className="intro-content-inner" >
                                    <StyleRoot>
                                        <h2 className="h2 overlay-dark " style={styles.fadeInDown}>Notre amendement Teranga est disponible<br/><a href="/produits/teranga"><button className="btn btn-md btn-black-line amendement_btn">En savoir plus</button></a></h2>
                                          
                                          </StyleRoot>
                                        <br />
                                        {/*<blockquote><small className="quote">"Stephane FOLL (ancien ministre de l'agriculture français)"</small></blockquote>                  
                                          <div><a className="btn btn-md btn-white-line xs-hidden">En savoir plus</a><span className="btn-space-10 xs-hidden"></span></div>*/}
                                    </div>
                                    

                                </div>
                            </div>

                        </div>
                    </li>


                <li data-slide="dark-slide">
                        <div className="slide-bg-image  dark-bg parallax parallax-section1">
                            <div className="js-Slide-fullscreen-height container">
                                <div className="intro-content">
                                
                                    <div className="intro-content-inner" >
                                    <StyleRoot>
                                          <h2 className="h2 overlay-dark " style={styles.fadeInDown}>"Des solutions naturelles pour une agriculture saine et durable"</h2>
                                      </StyleRoot>
                                        <br />
                                        {/*<div><a className="btn btn-md btn-white-line xs-hidden">En savoir plus</a><span className="btn-space-10 xs-hidden"></span></div>*/}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </li>

                     <li data-slide="dark-slide">
                        <div className="slide-bg-image s parallax parallax-section1 parasection">
                            <div className="js-Slide-fullscreen-height container">
                                <div className="intro-content">
                                   
                                     <div className="intro-content-inner" >
                                    <StyleRoot>
                                        <h2 className="h2 overlay-dark " style={styles.fadeInDown}>"L'Agroécologie est un choix de durabilité pour l'agriculture. C'est un mouvement de fond"<br/><small className="steph">Stéphane LEFOLL<br/><small className="lefoll">(Ancien ministre français de l'agriculture)</small></small></h2>
                                          
                                          </StyleRoot>
                                        <br />
                                        {/*<blockquote><small className="quote">"Stephane FOLL (ancien ministre de l'agriculture français)"</small></blockquote>                  
                                          <div><a className="btn btn-md btn-white-line xs-hidden">En savoir plus</a><span className="btn-space-10 xs-hidden"></span></div>*/}
                                    </div>
                                    

                                </div>
                            </div>

                        </div>
                    </li>



                    
                   
                  

                </ul>
            

            </div>

                {/*<div className="scroll-down">
                    <a className="btn js-scroll-trigger" href="#greenagro">
                     <Bounce infinite>
                            <img src="/assets/img/images/scroll_white.png" className="scroller"/>
                             </Bounce>
                    </a>
                </div>*/}


           
        </section>
             {this.props.children}
                <Awards/>
                <Products/>
            {/*<Apropos/>*/}
                <Service/>
                <Partenaires/>
              
    </div>
       
        

    )
  }
}
export default Slide;


// WEBPACK FOOTER //
// ./src/components/slideshow.jsx